import { Component, OnInit, OnDestroy, ViewChild, Input } from '@angular/core';
import { AngularFirestore, QueryFn } from 'angularfire2/firestore';
import { MatDataGridComponent } from '../../../../comum/controls/mat-datagrid';
import { Fornecedores, IFornecedores } from '../../../../models/fornecedores.model';
import { DataModelComponent } from '../../../../models/data.model.component';
import { MatSort, MatPaginator } from '@angular/material';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { UsersService } from '../../../../models/usuarios.service';
import { Localidades } from '../../../../models/localidades.model';
import { NavigatorGeolocation } from '../../services/navigator_geolocation';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { TextSearch } from '../../../../comum/textSearch';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'forn-lista',
  templateUrl: './forn-lista.html',
  styleUrls: ['./forn-lista.scss']
})

export class FornListaComponent extends DataModelComponent<IFornecedores> implements OnInit, OnDestroy {
  form: FormGroup;
  editing = false;
  item: IFornecedores;
  fornecedoresClass: Fornecedores;
  searchText = '';
  fornecedores: IFornecedores[] = [];
  dataSource = [];
  regiao: any = {};
  @Input() pageSize = 5;


  pageIndex: number;
  oldPageIndex: number;

  colunas = [
    { field: 'codigo', text: 'Código' },
    { field: 'nome', text: 'Nome' },
    { field: 'afiliado', text: 'Afiliado' },
    { field: 'regiao', text: 'regiao', fn: (x) => this.getRegiaoString(x) },
  ];

  @ViewChild(MatDataGridComponent) grid: MatDataGridComponent;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  regiaoSelecionada: string;
  regiaoClass: Localidades;
  selecionarRegiao = false;
  regioes = [{ nome: 'todas', regiao: 'todas' }];



  // ngAfterViewInit() {
  // }

  @Input()
  get verInativos() {
    return this.fornecedoresClass.verInativo;
  }
  set verInativos(x) {
    this.fornecedoresClass.verInativo = x;
  }

  constructor(
    private users: UsersService,
    private db: AngularFirestore,
    private _fb: FormBuilder,
    private router: Router,
    public sanitizer: DomSanitizer,
    private http: HttpClient) {
    super({
      codigo: new FormControl(),
      nome: new FormControl(),
      razaoSocial: new FormControl(),
      missao: new FormControl(),
      inativo: new FormControl(),
      mostrarMenu: new FormControl(),
      mostrarMaster: new FormControl(),
      img: new FormControl(),
      cobrarFreteAPartir: new FormControl(),
      comissao: new FormControl(),
      responsavelNome: new FormControl(),
    }
    );
  }

 formataRegiao(item){
   if (item.nome.indexOf(item.estado)<0)
   return item.nome+'-'+item.estado;
   else  return item.nome;
 }

  ngOnInit() {
    this.selecionarRegiao = this.users.isAdmin;

    if (this.users.regiaoLogada) {
      this.regiaoSelecionada = this.users.regiaoLogada;
    }

    this.fornecedoresClass = new Fornecedores(this.db, false);
    this.fornecedoresClass.users = this.users;

    if (this.regiaoSelecionada != null) {
      this.pesquisar();
    } else {

      if (!this.selecionarRegiao) {
        this.pesquisar();
      } else {

        this.regiaoClass = new Localidades(this.db);
        this.regiaoClass.snapshot((w) => {
          return w.where('inativo', '==', false);
        }, (rsp: any[]) => {
          this.regioes = [];
          rsp.forEach(elem => {
            this.regioes.push({ nome: this.formataRegiao(elem), regiao: this.formataRegiao(elem) });
          });
          this.regioes.push({ nome: 'todas', regiao: 'todas' });
          console.log(this.regioes);
        });
      }
    }
  }

  abrirRegiao() {
    // this.regiaoSelecionada = reg;
    this.pesquisar();
  }



  pesquisar(startAfterCursor?: string) {
    this.fornecedoresClass.snapshot(
      (elem) => {

        let query;
        if (this.users.isAfiliado) {
          query = elem.where('inativo', '==', this.verInativos).where('afiliado', '==', this.users.codigo);
        } else {
          query = elem.where('inativo', '==', this.verInativos);
        }
        if (this.regiaoSelecionada != null && this.regiaoSelecionada !== 'todas' ) {
          const regiaoField = 'regiao.' + TextSearch.toFieldNameFormat(this.regiaoSelecionada);
          query = query.where(regiaoField, '==', true);
          console.log(regiaoField);
        }
        return query;

      },
      (data) => {
        this.dataSource = data;
      }
      , false);
  }




  regiaoChange(lista: any[]) {
    const r: any = {};
    lista.forEach(element => {
      r[element] = true;
    });
    this.item.regiao = r;
  }

  getRegiaoString(item) {
    let s = '';
    if (item) {
      for (const key of Object.keys(item)) {
        if (s !== '') {
          s += ';';
        }
        s += key;
      }
    }
    if (s.length > 120) {
      return s.substring(0, 120) + '...';
    } else {
      return s;
    }
  }


  getFilterAttrib() {
    return 'Somente inativos';
  }


  ngOnDestroy() {
  }

  fetch() {
    return this.fornecedores;
  }

  updateValue(event, cell, rowIndex) {
  }

  editar(elem) {
    this.oldPageIndex = this.grid.pageIndex;
    super.doEditItem(elem);
    this.regiao = elem.regiao;
  }

  adicionar(elem?) {
    super.doNewItem(elem);
    this.doGerarCodigo();
  }

  dataPath(img) {
    this.item.imgSrc = img;
  }

  doPostItem(values) {

    if (this.users.isAfiliado && !this.item.afiliado) {
      this.item.afiliado = this.users.codigo;
    }

    if (!this.item.token) {
      this.item.token = this.fornecedoresClass.newGuid();
    }
    this.fornecedoresClass.post(this.item);

    super.doPostItem(values);
    this.pageIndex = this.oldPageIndex;
    this.getAfiliado(this.item.afiliado);
  }

  cancelar() {
    this.editing = false;
    this.pageIndex = this.oldPageIndex;
  }

  doGerarCodigo() {
    this.fornecedoresClass.gerarNovoCodigo(
      r => {
        this.item.codigo = r.valor;
      }
    );
  }

  doChangeImage(event) {
    this.item.img = event;
  }

  doItemClick(element) {
    this.router.navigate(['/produtosFornecedor/' + element.codigo]);
  }

  doEditItem(element) {
    this.oldPageIndex = this.grid.pageIndex;
    super.doEditItem(element);
    if (this.inserting) {
      this.doGerarCodigo();
    }
    this.getAfiliado(element.afiliado);
  }

  doCheckFilter(x: boolean) {
    if (this.verInativos !== this.grid.checkFilterValue) {
      this.verInativos = this.grid.checkFilterValue;
      this.pesquisar();
    }
  }


  // tslint:disable-next-line:member-ordering
  fAfiliado: any = { codigo: null, nome: '' };
  nomeAfiliado(codigo) {
    return this.fAfiliado.nome;
  }

  getAfiliado(codigo: number) {
    if (!codigo) { this.fAfiliado = { codigo: codigo, nome: '' }; } else {
      if (!this.fAfiliado.codigo || this.fAfiliado.codigo !== codigo) {
        this.fAfiliado.codigo = { codigo: codigo, nome: '' };
        this.users.getUsuario(codigo, d => {
          this.fAfiliado = d;
          return this.fAfiliado.nome;
        });
      } else {
        return this.fAfiliado.nome;
      }
    }
  }


  buscarGeolocation() {
    const ng = new NavigatorGeolocation(this.http);


    const x: any = this.item;
    const ender = x.endereco + ',' + x.cidade + ',' + x.estado + ',BR,CEP ' + x.cep;
    const rsp = ng.getGeoLocationByAddress(ender)
      .subscribe(coord => {
        this.item.latitude = coord.lat;
        this.item.longitude = coord.lng;
      });

  }

  // tslint:disable-next-line:member-ordering
  googleMapUrl = '';
  verMapa() {
    if (this.item.latitude && this.item.longitude) {
      const ng = new NavigatorGeolocation(this.http);
      this.googleMapUrl = ng.getGoogleMapUrl(this.item.latitude, this.item.longitude);
      window.open(this.googleMapUrl);
    }
  }

  doPageChange(argEvent: any) {
    // se avançou para próxima
    if (argEvent.previousPageIndex < argEvent.pageIndex) {
      if (this.dataSource && (this.dataSource.length > 0)) {
        const startAfterCursor = this.dataSource[this.dataSource.length - 1].nome;
        this.pesquisar(startAfterCursor);
      }
    }
  }

  assignOrPush(data: Array<any>) {
    // console.log(data.length)
    if (!(this.dataSource && this.dataSource.length > 0)) {
      this.dataSource = data;
    } else {
      if (data && data.length > 0) {
        const arr = [];
        for (const elem of data) {
          const idx = this.dataSource.findIndex((item) => (item.codigo === elem.codigo));
          if (idx === -1) {
            // se não existe insere, existe atualiza
            arr.push(elem);
          } else {
            this.dataSource[idx] = elem;
          }
        }
        // se não atribuir os dados de uma vez, não atualiza a view
        this.dataSource = [...this.dataSource, ...arr];
        this.dataSource.sort(function (a: any, b: any) { return (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0); });
        this.fornecedores = this.dataSource;
      }
    }
  }


  doSearch(value: string) {

    this.searchText = value;
    this.dataSource = [];
    this.pesquisar();
  }

}
